import { render } from "./App.vue?vue&type=template&id=33728516"
const script = {}

import "./App.vue?vue&type=style&index=0&id=33728516&lang=css"
script.render = render

export default script